"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { Action } from "../actions";
export default function textEditingModeReducer(editedTextAnnotation = null, action) {
  switch (action.type) {
    case Action.EDIT_TEXT_ANNOTATION: {
      const { textAnnotation } = action;
      return textAnnotation;
    }
    case Action.EDIT_TEXT_ANNOTATION_TEXT: {
      const { guid, value } = action;
      if (!editedTextAnnotation || guid !== editedTextAnnotation.guid) {
        return editedTextAnnotation;
      }
      return __spreadProps(__spreadValues({}, editedTextAnnotation), {
        data: __spreadProps(__spreadValues({}, editedTextAnnotation.data), {
          text: value
        })
      });
    }
    case Action.SELECT_HOVERED_COMPONENT: {
      const { hover, views } = action;
      if (hover.viewID) {
        const annotation = views[hover.viewID];
        if (annotation.typeID === "TextAnnotation") {
          return annotation;
        }
        return null;
      }
      return null;
    }
    case Action.DONE_EDITING_TEXT_ANNOTATION: {
      return null;
    }
    case Action.SAVING_ANNOTATIONS_SUCCEEDED: {
      return null;
    }
    case Action.UNSELECT_COMPONENT: {
      const { guid } = action;
      if (editedTextAnnotation && editedTextAnnotation.guid === guid) {
        return null;
      }
      return editedTextAnnotation;
    }
    case Action.DELETE_COMPONENT: {
      const { guid } = action;
      if (editedTextAnnotation && editedTextAnnotation.guid === guid) {
        return null;
      }
      return editedTextAnnotation;
    }
    default:
      return editedTextAnnotation;
  }
}
